// extracted by mini-css-extract-plugin
export default {"NavMobile":"style_NavMobile__9s295","bell_comment":"style_bell_comment__Z9xST","logo":"style_logo__R5q07","burger":"style_burger__zu6oi"};